import * as angular from "angular";

let StreetsViewComponent = {
    selector: "vcStreetsView",
    templateUrl: "/angular/components/street/streets-view.component.html",
    bindings: {
        doubleToolbar: "=?",
    },
    controller: "PeopleController",
};

angular
    .module("street")
    .component(StreetsViewComponent.selector, StreetsViewComponent);
